module.exports = __webpack_public_path__ + "static/img/9.21d387f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/9.png
// module id = EooJ
// module chunks = 0